import { API_ENDPOINT } from '../config';
import { parseCookie } from './utils';

export default function(performance_provider_id, sector_key, price) {
    return fetch(`${API_ENDPOINT}/seats/${performance_provider_id}/set-ga/`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': parseCookie().csrftoken
        },
        body: JSON.stringify({
            key: sector_key,
            price: price
        })
    });
}
